import React, { useEffect } from "react";
import Icon from "@mdi/react";
import {
  mdiBarcodeScan,
  mdiFileDelimitedOutline,
  mdiUploadOutline,
} from "@mdi/js";

interface DeviceScanModalInwardProps {
  open: boolean;
  activeTab: "scan" | "bulk" | "upload";
  setActiveTab: (tab: "scan" | "bulk" | "upload") => void;
  showBulkTabs?: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const DeviceScanModalInward: React.FC<DeviceScanModalInwardProps> = ({
  open,
  activeTab,
  setActiveTab,
  showBulkTabs = false,
  onClose,
  children,
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      id="warehouse-inward-scan-modal"
      className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-40"
    >
      <div className="flex min-h-full items-start justify-center p-4">
        <div
          className="bg-white w-full max-w-2xl rounded-xl shadow-xl wh-modal-xs"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="font-semibold text-lg">Scan Devices</h3>
            <button
              id="warehouse-inward-scan-modal-close"
              onClick={onClose}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          {showBulkTabs && (
            <div className="grid grid-cols-3 bg-gray-100 rounded-md p-1 m-4 mb-2">
              {[
                { key: "scan", label: "Scan", icon: mdiBarcodeScan },
                {
                  key: "bulk",
                  label: "Bulk Paste",
                  icon: mdiFileDelimitedOutline,
                },
                { key: "upload", label: "Upload CSV", icon: mdiUploadOutline },
              ].map((t) => (
                <button
                  key={t.key}
                  id={`warehouse-inward-scan-modal-tab-${t.key}`}
                  type="button"
                  onClick={() => setActiveTab(t.key as typeof activeTab)}
                  className={`flex items-center justify-center gap-2 py-2 text-xs font-medium rounded-md transition ${
                    activeTab === t.key
                      ? "bg-white shadow"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  <Icon path={t.icon} size={0.6} />
                  {t.label}
                </button>
              ))}
            </div>
          )}

          {/* Content */}
          <div className="p-4 space-y-3">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default DeviceScanModalInward;
